import { render, staticRenderFns } from "./LeaveEdit.vue?vue&type=template&id=6c7b9b0d&"
import script from "./LeaveEdit.vue?vue&type=script&lang=js&"
export * from "./LeaveEdit.vue?vue&type=script&lang=js&"
import style0 from "./LeaveEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports